// extracted by mini-css-extract-plugin
export default {"h1":"style__h1___rGn2I","navBar":"style__navBar___afcIs","navItem":"style__navItem___2WZZw","navList":"style__navList___9frg3"};